import Button from "../ui/Button";
import { Input } from "../ui/Input";
import { Text } from "../ui/Text";
import { useForm } from "react-hook-form";
import {toast} from 'react-hot-toast'
interface IForm {
  request: string;
  contact: string;
}
export const Form = () => {
  const methods = useForm<IForm>();
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = methods;

  const onSubmit = async (data: IForm) => {
    const response = await fetch(`${import.meta.env.VITE_API_SERVER}/api/send`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: data.request,
        contact: data.contact,
      }),
    });
    if(response.status === 200) {
      toast.success('Мы получили Вашу заявку')
      reset()
    } else {
      toast.error('Произошла ошибка')
    }
  };
  return (
    <div
      id="form"
      className="pt-30 w-full flex flex-col items-center px-5 md:scroll-m-30 scroll-m-5 mb-215 "
    >
      <div className="flex flex-col gap-6 max-w-170 w-full sm:gap-14 items-center">
        <div className="flex flex-col gap-3 sm:gap-4.5 items-center">
          <Text type="title">Оставьте заявку</Text>
          <Text type="main" className="text-center">
            {
              <>
                Наша команда проведет бесплатный аудит
                <br />и составит детальную смету по вашему проекту
              </>
            }
          </Text>
        </div>
        <div className="flex flex-col gap-6 sm:gap-11 w-full items-center">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col sm:gap-6 gap-3 w-full"
            id="contact_form"
          >
            <Input
              placeholder="Нужен сайт для цветочного магазина..."
              className="h-40"
              {...register("request", {
                required: "Поле не может быть пустым",
              })}
              textarea
              error={errors.request?.message}
            ></Input>
            <Input
              {...register("contact", {
                required: "Поле не может быть пустым",
              })}
              placeholder="Telegram, Whatsapp или email"
              error={errors.contact?.message}
            ></Input>
          </form>
          <Button type="submit" form="contact_form">
            Отправить
          </Button>
        </div>
      </div>
    </div>
  );
};
